import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { DropdownModule } from '@avenir-client-web/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { FilterOption, SearchCounts } from '../interfaces/search.interfaces';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TabViewModule, DropdownModule],
})
export class SearchFilterComponent<T = unknown> implements OnChanges {
  @Input() filterTitle: string;

  @Input() options: FilterOption<T>[] = [];

  @Input() filter: unknown;

  @Input() searchCounts: SearchCounts;

  @Output() filterChange = new EventEmitter<unknown>();

  filterIdx = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter) {
      this.filterIdx = this.options.findIndex(x => x.value === this.filter);
    }
  }

  valueChange(idx: number, isUsingIdx = true): void {
    const value = isUsingIdx ? this.options[idx].value : idx;

    this.filterChange.emit(value);
  }
}
